export const reportVerbiage: { [K in 'en' | 'es']: { [key: string]: string } } = {
  en: {
    aboutYourCondition: 'About your condition',
    yourExercisePlan: 'Your exercise plan',
    keyExamFindings: 'Key exam findings',
    whatsWrong: `What's Wrong?`,
    thingsWeCanDoToHelpYou: `Things We Can Do to Help You`,
    treatmentGoalsAndOutcomeMeasures: `Treatment Goals and Outcome Measures`,
    thingsYouCanDoToHelpYourself: `Things You Can Do to Help Yourself`,
    exercisesAtHome: `Exercises at Home`,
    theFollowingExercises:
      'The following exercises have been specifically selected to assist with your recovery and help minimize future problems. Exercises should be performed slowly and within a relatively comfortable range. Maintain good posture and breathe naturally. Do not hold your breath. Unless otherwise instructed, stop any exercises that cause pain, or radiating symptoms.',
    accessYourExerciseVideos: 'Access your exercise videos',
    scanMe: 'Scan me',
    treatment1: 'Your treatment will be most effective when scheduled at a rate of',
    treatment2:
      'After this initial course of treatment we will reassess to make sure that you have met your initial treatment goal of at least',
    treatment3: 'overall improvement.',
    treatment4: 'We will determine the need for any additional care after your reassessment.',
    day: 'day',
    week: 'week',
    month: 'month',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    for: 'for',
    timePer: 'time per',
    timesPer: 'times per',
    then: 'then',
    or: 'or',
    visitHealthCom: 'Visit HealthCom.io',
    currentExercises: 'Current Exercises',
    stop: 'Stop!',
    followingUpcomingExercises:
      'The following upcoming exercises will be started at a later date as you progress. Do not begin upcoming exercises until you are directed to do so by our office. You will continue your current exercises until otherwise directed.',
    upcomingExercises: 'Upcoming exercises',
    username: 'Username',
    password: 'Password',
    currentPassword: 'Current Password',
    // New OTP-based login copy. Replaces the username/password block on
    // the printed + emailed condition reports.
    signInToHealthCom: 'Sign in to HealthCom',
    signInInstructions:
      "Visit HealthCom.io and enter the email or phone number on file with our office. We'll send you a 6-digit code to sign in — no password needed.",
    yourEmailOnFile: 'Your email on file',
    yourPhoneOnFile: 'Your phone on file',
  },
  es: {
    aboutYourCondition: 'Acerca de su condición',
    yourExercisePlan: 'Tu plan de ejercicio',
    keyExamFindings: 'Resultados clave del examen',
    whatsWrong: `¿Qué hay de mal?`,
    thingsWeCanDoToHelpYou: `Cosas que podemos hacer para ayudarlo`,
    treatmentGoalsAndOutcomeMeasures: `Metas de tratamiento y medidas de resultados`,
    thingsYouCanDoToHelpYourself: `Cosas que puedes hacer para ayudarte a ti mismo`,
    exercisesAtHome: `Ejercicios en casa`,
    theFollowingExercises:
      'Los siguientes ejercicios han sido seleccionados específicamente para ayudarlo con su recuperación y minimizar problemas futuros. Los ejercicios deben realizarse lentamente y dentro de un rango relativamente cómodo. Mantenga una buena postura y respire naturalmente. No contengas la respiración. A menos que se le indique lo contrario, deje de hacer ejercicios que le causen dolor o irradien síntomas.',
    accessYourExerciseVideos: 'Acceso a sus vídeos de ejercicios',
    scanMe: 'Escanéame',
    treatment1: 'Su tratamiento será más efectivo cuando se programen a una frecuencia de',
    treatment2:
      'Después de este curso inicial de tratamiento, volveremos a evaluar para asegurarnos de que haya alcanzado su objetivo de tratamiento inicial de al menos',
    treatment3: 'mejora general.',
    treatment4:
      'Determinaremos la necesidad de cualquier atención adicional después de su reevaluación.',
    day: 'día',
    week: 'semana',
    month: 'mes',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    for: 'para',
    timePer: 'una vez al',
    timesPer: 'veces por',
    then: 'entonces',
    or: 'o',
    visitHealthCom: 'Visite HealthCom.io',
    currentExercises: 'Ejercicios actuales',
    stop: 'Detener!',
    followingUpcomingExercises:
      'Los siguientes ejercicios próximos se iniciarán en una fecha posterior como usted progresa. No comience ejercicios próximos hasta que sea indicado por nuestro departamento. Continuará con sus ejercicios actuales hasta que sea indicado por nuestro departamento.',
    upcomingExercises: 'Ejercicios próximos',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    currentPassword: 'Contraseña actual',
    signInToHealthCom: 'Iniciar sesión en HealthCom',
    signInInstructions:
      'Visite HealthCom.io e ingrese el correo electrónico o número de teléfono que tiene registrado en nuestra oficina. Le enviaremos un código de 6 dígitos para iniciar sesión — no necesita contraseña.',
    yourEmailOnFile: 'Su correo electrónico registrado',
    yourPhoneOnFile: 'Su teléfono registrado',
  },
};
